// Desenhos técnicos de fundo da Luteria Fagundes (vetores em assets/desenhos/).
// Marque um contêiner com:
//   data-desenho="voluta-olho"      → carrega assets/desenhos/voluta-olho.svg
//   data-desenho-atraso="300"       → atraso em ms antes de começar a traçar
//   data-desenho-duracao="4200"     → tempo total do traçado em ms
//   data-desenho-op=".8"            → opacidade relativa deste desenho (multiplica a força global)
// O desenho se forma traço a traço quando entra na tela; nos logos, o preenchimento
// surge depois do contorno. Respeita prefers-reduced-motion.
(function () {
  if (window.LFDesenhos) return;
  const BASE = (window.LF_DES_BASE || '');
  const EASE = 'cubic-bezier(.35,0,.15,1)';
  const TRACO = .55;      // espessura relativa do traço
  const PREENCHE = .1;    // opacidade final do preenchimento dos logos
  const cache = {};
  const montados = new WeakSet();
  const tracados = new WeakSet();
  const cfg = { animado: true, visivel: true, cor: null, forca: null };
  let io = null, mo = null, timer = null, debounce = null;
  const reduz = () => !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  const linhas = el => [...el.querySelectorAll('path:not([data-preencher])')];
  const cheios = el => [...el.querySelectorAll('path[data-preencher]')];

  function carregar(nome) {
    return cache[nome] || (cache[nome] = fetch(BASE + 'lf-des-' + nome + '.svg').then(r => r.ok ? r.text() : '').catch(() => ''));
  }

  function aplicarCfg(el) {
    if (cfg.cor) el.style.color = cfg.cor;
    const base = Number(el.dataset.desenhoOp || 1);
    if (cfg.forca != null) el.style.opacity = String(Math.max(0, Math.min(1, base * cfg.forca)));
    el.style.display = cfg.visivel ? '' : 'none';
  }

  function cancelar(p) { p.getAnimations && p.getAnimations().forEach(a => { try { a.cancel(); } catch (_) {} }); }

  function prontos(el) {
    linhas(el).forEach(p => { cancelar(p); p.style.strokeDashoffset = '0'; });
    cheios(el).forEach(p => { cancelar(p); p.style.fillOpacity = String(PREENCHE); });
  }

  function tracar(el) {
    if (tracados.has(el)) return;
    tracados.add(el);
    if (io) io.unobserve(el);
    if (!cfg.animado || reduz()) { prontos(el); return; }
    const paths = linhas(el);
    const n = paths.length;
    const atraso = Number(el.dataset.desenhoAtraso || 0);
    const total = Number(el.dataset.desenhoDuracao || 4200);
    const dur = Math.min(1700, total * .45);
    const passo = n > 1 ? (total - dur) / (n - 1) : 0;
    paths.forEach((p, i) => {
      try {
        const a = p.animate([{ strokeDashoffset: 1 }, { strokeDashoffset: 0 }], { duration: dur, delay: atraso + i * passo, easing: EASE, fill: 'forwards' });
        a.onfinish = () => { p.style.strokeDashoffset = '0'; try { a.cancel(); } catch (_) {} };
      } catch (_) { p.style.strokeDashoffset = '0'; }
    });
    cheios(el).forEach(p => {
      try {
        const a = p.animate([{ fillOpacity: 0 }, { fillOpacity: PREENCHE }], { duration: 1600, delay: atraso + total * .8, easing: 'ease-out', fill: 'forwards' });
        a.onfinish = () => { p.style.fillOpacity = String(PREENCHE); try { a.cancel(); } catch (_) {} };
      } catch (_) { p.style.fillOpacity = String(PREENCHE); }
    });
    if (el.dataset.desenhoLoop !== '0') {
      clearTimeout(el.__ciclo);
      el.__ciclo = setTimeout(() => apagar(el), atraso + total + 3200);
    }
  }

  // Por padrão o traço some seguindo o mesmo sentido e se forma de novo, sem parar (data-desenho-loop="0" desliga).
  function apagar(el) {
    if (!el.isConnected || !cfg.animado || reduz()) return;
    const paths = linhas(el);
    const n = paths.length;
    const total = Math.min(2600, Number(el.dataset.desenhoDuracao || 4200) * .6);
    const dur = Math.min(1400, total * .5);
    const passo = n > 1 ? (total - dur) / (n - 1) : 0;
    paths.forEach((p, i) => {
      try {
        const a = p.animate([{ strokeDashoffset: 0 }, { strokeDashoffset: -1 }], { duration: dur, delay: i * passo, easing: EASE, fill: 'forwards' });
        a.onfinish = () => { p.style.strokeDashoffset = '1'; try { a.cancel(); } catch (_) {} };
      } catch (_) { p.style.strokeDashoffset = '1'; }
    });
    cheios(el).forEach(p => { try { p.animate([{ fillOpacity: PREENCHE }, { fillOpacity: 0 }], { duration: 900, easing: 'ease-in', fill: 'forwards' }).onfinish = () => { p.style.fillOpacity = '0'; }; } catch (_) { p.style.fillOpacity = '0'; } });
    clearTimeout(el.__ciclo);
    el.__ciclo = setTimeout(() => {
      if (!el.isConnected) return;
      tracados.delete(el);
      const at = el.dataset.desenhoAtraso; el.dataset.desenhoAtraso = '0';
      tracar(el);
      el.dataset.desenhoAtraso = at || '';
    }, total + 900);
  }

  async function montar(el) {
    if (montados.has(el)) return;
    montados.add(el);
    const txt = await carregar(el.dataset.desenho);
    if (!txt || !el.isConnected) { montados.delete(el); return; }
    el.innerHTML = txt;
    const svg = el.querySelector('svg');
    if (!svg) return;
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.style.cssText = 'display:block;width:100%;height:auto;overflow:visible';
    linhas(el).forEach(p => {
      p.setAttribute('vector-effect', 'non-scaling-stroke');
      p.style.strokeWidth = String(Number(p.dataset.w || .6) * TRACO);
      p.style.strokeDasharray = '1';
      p.style.strokeDashoffset = '1';
    });
    cheios(el).forEach(p => { p.style.fill = 'currentColor'; p.style.fillOpacity = '0'; });
    aplicarCfg(el);
    if (!cfg.animado || reduz()) { tracar(el); return; }
    if (io) io.observe(el); else conferir();
  }

  function varrer() {
    document.querySelectorAll('[data-desenho]').forEach(el => { aplicarCfg(el); montar(el); });
  }

  // Rede de segurança caso o observer não dispare (zoom, contêineres rolados etc.)
  function conferir() {
    const vh = window.innerHeight, vw = window.innerWidth;
    document.querySelectorAll('[data-desenho]').forEach(el => {
      if (tracados.has(el) || !el.querySelector('svg')) return;
      const r = el.getBoundingClientRect();
      if (r.width && r.bottom > 0 && r.top < vh * .95 && r.right > 0 && r.left < vw) tracar(el);
    });
  }

  function ligar() {
    if (mo) return;
    io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) tracar(e.target); }), { threshold: .08, rootMargin: '0px 0px -4% 0px' }) : null;
    mo = new MutationObserver(() => { clearTimeout(debounce); debounce = setTimeout(varrer, 120); });
    mo.observe(document.body, { childList: true, subtree: true });
    timer = setInterval(conferir, 700);
    varrer();
  }

  window.LFDesenhos = {
    // { animado, visivel, cor, forca }
    config(o) {
      Object.assign(cfg, o || {});
      document.querySelectorAll('[data-desenho]').forEach(el => {
        aplicarCfg(el);
        if (!cfg.animado && el.querySelector('svg')) { tracados.add(el); prontos(el); }
      });
    },
    // Reinicia o traçado de um desenho (para rever a animação)
    refazer(el) {
      if (!el || !el.querySelector('svg')) return;
      tracados.delete(el);
      linhas(el).forEach(p => { cancelar(p); p.style.strokeDashoffset = '1'; });
      cheios(el).forEach(p => { cancelar(p); p.style.fillOpacity = '0'; });
      tracar(el);
    }
  };

  if (document.body) ligar(); else document.addEventListener('DOMContentLoaded', ligar);
})();
